module.exports = __webpack_public_path__ + "media/images/no-image-available-c4bb85cac4d9a200c5a8fbf08b9ecaec.png";